import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'
import useRouteParser from 'src/hooks/routeParser'

const { t } = useI18n()
const { toArray, getPaginationCasts, getPaginationInject } = useRouteParser()

const module: RouteRecordRawArgumented = {
  path: 'coefficients-thresholds-branch',
  name: 'coefficientsThresholdsBranch',
  component: () =>
    import(
      /* webpackChunkName: "coefficients-thresholds-branch" */ 'pages/order-bot/FiveThresholdsCoefficientsBranch.vue'
    ),
  meta: {
    breadcrumb: {
      name: t('breadcrumb.order_bot.coefficients_thresholds_branch'),
      icon: 'mdi-numeric-5-box-multiple-outline',
    },
    auth: {
      permission: 'order_bot_manage',
    },
    inject: {
      query: {
        ...getPaginationInject(),
        sort: 'updated_at',
        dir: 'desc',
      },
    },
    casts: {
      query: {
        ...getPaginationCasts(),
        class: toArray,
        warehouse_id: toArray,
        logistics_class: toArray,
      },
    },
    encode: {
      query: {
        class: JSON.stringify,
        warehouse_id: JSON.stringify,
        logistics_class: JSON.stringify,
      },
    },
  },
  children: [
    {
      path: 'upload-coefficients-thresholds-branch',
      name: 'uploadFiveThresholdsCoefficientsBranch',
      component: () =>
        import(
          /* webpackChunkName: "upload-coefficients-thresholds-branch" */ 'pages/order-bot/UploadFiveThresholdsCoefficientsBranch.vue'
        ),
      meta: {
        breadcrumb: {
          icon: 'mdi-numeric-5-box-multiple-outline',
          name: t('breadcrumb.order_bot.upload_coefficients_thresholds_branch'),
        },
        auth: {
          permission: 'order_bot_manage',
        },
      },
    },
  ],
}

export default module
